<script lang="ts">
// Content is directly controlled by developers.
/* eslint-disable vue/no-v-html */
</script>

<script setup lang="ts">
import type { SlugBodyItem } from '..';

defineProps<{ item: SlugBodyItem }>();
</script>

<template>
  <article
    class="gap-r5 text-client-white group flex flex-col lg:flex-row lg:items-center lg:gap-0 lg:even:flex-row-reverse"
  >
    <div
      class="gap-r4 lg:mr-r18 lg:group-even:ml-r18 flex flex-col lg:w-1/2 lg:group-even:mr-0"
    >
      <AppHeading tag="h3" class="text-client-white font-bold!">
        {{ item.title }}
      </AppHeading>
      <AppParagraph as="div">
        <div v-html="item.description"></div>
      </AppParagraph>
    </div>
    <div
      class="lg:ml-r18 lg:group-even:mr-r18 aspect-3/2 w-full overflow-hidden rounded-lg lg:w-1/2 lg:group-even:ml-0"
    >
      <img
        :src="item.image.url"
        :alt="item.image.alt"
        class="size-full object-cover"
      />
    </div>
  </article>
</template>
